/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h, g as getElement } from './index-ef0fa435.js';

const listCss = "slot-fb[hidden],slot[hidden]{display:initial !important}lar-list-item{margin:0.4rem 0}";

const ListItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return h("slot", null);
  }
  get el() { return getElement(this); }
};
ListItem.style = listCss;

export { ListItem as lar_list };

//# sourceMappingURL=lar-list.entry.js.map